// bp-preorder v1.0 - Pre-Order badge + WhatsApp redirect for items arriving within 5 days
(function() {
  'use strict';

  var S = '.product-item, .card-wrapper, .product-card';
  var WHATSAPP_NUMBER = '971504504831'; // Your WhatsApp number

  // Parse product tags from data-json-product attribute
  function getProductTags(card) {
    var j = card.getAttribute('data-json-product');
    if (!j) return [];
    try {
      var p = JSON.parse(j);
      return p.tags || [];
    } catch(e) { return []; }
  }

  // Get product handle from card
  function getHandle(card) {
    var h = card.getAttribute('data-product-handle');
    if (!h) {
      var j = card.getAttribute('data-json-product');
      if (j) { try { var p = JSON.parse(j); if (p.handle) h = p.handle; } catch(e) {} }
    }
    if (!h) {
      var l = card.querySelector('.card-title a, .card-title, .product-title a, a.card-title, a[href*="/products/"]');
      if (l) { var hr = l.getAttribute('href'); if (hr) { var m = hr.match(/\/products\/([^?#]+)/); if (m) h = m[1].split('?')[0]; } }
    }
    return h || '';
  }

  // Extract arrival date from tags (format: arrival-YYYY-MM-DD)
  function getArrivalDate(tags) {
    if (!tags || !tags.length) return null;
    for (var i = 0; i < tags.length; i++) {
      var match = tags[i].match(/^arrival-(\d{4}-\d{2}-\d{2})$/);
      if (match) return new Date(match[1]);
    }
    return null;
  }

  // Check if product is pre-order eligible
  function getPreOrderStatus(tags) {
    var isPreOrder = tags && tags.some(function(t) { return t.toLowerCase() === 'pre-order' || t.toLowerCase() === 'preorder'; });
    if (!isPreOrder) return { eligible: false, reason: 'none' };

    var arrivalDate = getArrivalDate(tags);
    if (!arrivalDate) {
      // No arrival date tag — treat as pre-order eligible (within 5 days)
      return { eligible: true, arrivalDate: null, daysUntil: null };
    }

    var now = new Date();
    var diffMs = arrivalDate.getTime() - now.getTime();
    var diffDays = Math.ceil(diffMs / (1000 * 60 * 60 * 24));

    if (diffDays <= 5 && diffDays >= 0) {
      return { eligible: true, arrivalDate: arrivalDate, daysUntil: diffDays };
    } else if (diffDays < 0) {
      return { eligible: false, reason: 'expired' };
    } else {
      return { eligible: false, reason: 'too_far', daysUntil: diffDays };
    }
  }

  // Format date nicely
  function formatDate(date) {
    if (!date) return '';
    var months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
    return months[date.getMonth()] + ' ' + date.getDate();
  }

  // Open WhatsApp with pre-filled pre-order message
  function openWhatsAppPreOrder(title, handle, arrivalText) {
    var msg = 'Hi! I want to pre-order: ' + title + 
              (arrivalText ? ' (Arriving ' + arrivalText + ')' : '') +
              '\nProduct: https://brandspoint.ae/products/' + handle +
              '\nPlease help me place this pre-order. Thank you!';
    window.open('https://wa.me/' + WHATSAPP_NUMBER + '?text=' + encodeURIComponent(msg), '_blank');
  }

  // Add pre-order badges and modify buttons
  function initPreOrder() {
    document.querySelectorAll(S).forEach(function(c) {
      // Skip if already processed
      if (c.querySelector('.bp-po-badge')) return;

      var tags = getProductTags(c);
      var status = getPreOrderStatus(tags);
      
      // Only show badge for pre-order products
      if (!tags.some(function(t) { return t.toLowerCase() === 'pre-order' || t.toLowerCase() === 'preorder'; })) return;

      var handle = getHandle(c);
      var title = '';
      var titleEl = c.querySelector('.card-title a, .card-title, .product-title a');
      if (titleEl) title = titleEl.textContent.trim();

      // Create badge element
      var badge = document.createElement('div');
      badge.className = 'bp-po-badge';

      if (status.eligible) {
        // Pre-order eligible — show badge with arrival info
        var arrivalText = status.arrivalDate ? 'Arrives ' + formatDate(status.arrivalDate) : 'Pre-Order Now';
        badge.innerHTML = '🔮 ' + arrivalText;
        badge.style.cssText = 'position:absolute;top:8px;left:8px;z-index:12;background:linear-gradient(135deg,#6366f1,#a855f7);color:#fff;font-size:10px;font-weight:700;padding:4px 10px;border-radius:4px;box-shadow:0 2px 8px rgba(99,102,241,0.4);text-transform:uppercase;letter-spacing:0.5px;';

        // Modify the add-to-cart button to become pre-order
        var atcBtn = c.querySelector('.bp-sb');
        if (atcBtn) {
          atcBtn.style.background = 'linear-gradient(135deg,#6366f1,#a855f7)';
          atcBtn.setAttribute('data-original-handler', atcBtn.onmousedown ? 'true' : 'false');
          
          // Replace onclick — redirect to WhatsApp
          atcBtn.onmousedown = function(e) {
            e.stopPropagation();
            e.preventDefault();
            openWhatsAppPreOrder(title || handle, handle, arrivalText);
          };
        }
      } else if (status.reason === 'too_far') {
        // Coming soon (more than 5 days away)
        badge.innerHTML = '🚀 Coming Soon';
        badge.style.cssText = 'position:absolute;top:8px;left:8px;z-index:12;background:#f59e0b;color:#fff;font-size:10px;font-weight:700;padding:4px 10px;border-radius:4px;';

        // Disable the add-to-cart button
        var atcBtn = c.querySelector('.bp-sb');
        if (atcBtn) {
          atcBtn.style.background = '#d1d5db';
          atcBtn.style.cursor = 'not-allowed';
          atcBtn.style.boxShadow = 'none';
          atcBtn.onmousedown = function(e) {
            e.stopPropagation();
            e.preventDefault();
          };
        }
      } else if (status.reason === 'expired') {
        return; // Already arrived — show nothing special
      }

      // Append badge to card
      var container = c.querySelector('.card-product__wrapper, .card-product') || c;
      if (container) {
        container.style.position = 'relative';
        container.appendChild(badge);
      }
    });
  }

  // ---- Init ----
  initPreOrder();
  setTimeout(initPreOrder, 1000);
  setTimeout(initPreOrder, 3000);
  new MutationObserver(function() { initPreOrder(); }).observe(document.body, { childList: true, subtree: true });
})();
